import { useEffect, useState } from 'react'

import { isValidArray, tr } from 'mmfintech-commons'
import { isJetonWallet, usePaymentOptions } from 'mmfintech-checkout-commons'

import { MethodPane } from './MethodPane'
import { MethodButton } from './MethodButton'
import { SelectMethodContainer, SelectMethodEmpty, SelectMethodStyled, SelectMethodTitle } from './SelectMethod.styled'

import type { PaymentOptionResponse } from 'mmfintech-checkout-commons/types'

type SelectMethodProps = {
  className?: string
  method?: string
  setMethod?: (method: string) => void
  countryCode?: string
  special?: boolean
}

export const SelectMethod = ({ className, method, setMethod, countryCode, special }: SelectMethodProps) => {
  const [options, setOptions] = useState<PaymentOptionResponse[]>(null)

  const { paymentOptions, paymentOptionsFetching } = usePaymentOptions()

  useEffect(() => {
    if (isValidArray(paymentOptions) && special) {
      setOptions(paymentOptions.filter(option => !isJetonWallet(option.paymentMethod)))
    } else {
      setOptions(paymentOptions)
    }
    // eslint-disable-next-line
  }, [paymentOptions, special])

  useEffect(() => {
    if (Array.isArray(options) && options.length === 1) {
      setMethod(options[0].paymentMethod)
    }
    // eslint-disable-next-line
  }, [options])

  if (isValidArray(options)) {
    if (options.length > 1) {
      return (
        <SelectMethodStyled>
          <SelectMethodTitle>{tr('CHECKOUT.SELECT.METHOD.PAYMENT_WITH', 'Payment With')}</SelectMethodTitle>
          <SelectMethodContainer className={className}>
            {options.map(option => (
              <MethodButton
                key={option.paymentMethod}
                name={option.paymentMethod}
                selected={option.paymentMethod === method}
                setSelected={setMethod}
              />
            ))}
          </SelectMethodContainer>
        </SelectMethodStyled>
      )
    }

    return (
      <SelectMethodStyled>
        <SelectMethodTitle>{tr('CHECKOUT.SELECT.METHOD.PAYING_WITH', 'Paying With')}</SelectMethodTitle>
        <MethodPane method={method} />
      </SelectMethodStyled>
    )
  }

  return countryCode && !paymentOptionsFetching ? (
    <SelectMethodStyled>
      <SelectMethodEmpty>{tr('CHECKOUT.PAYMENT.NO_METHODS', 'No payment methods available')}</SelectMethodEmpty>
    </SelectMethodStyled>
  ) : null
}
